import React from 'react'

import Carousel from './Carousal'
import Banner from './Banner'
import Footer from './Footer'

import Videos from '../pages/Videos'
import Founders from '../pages/Founders'
import Maps from '../pages/Maps'
import Compnay from '../pages/Compnay'
import Owner from '../pages/Owner'
import CompanyOne from "../pages/CompanyOne";
import CompanyTwo from "../pages/CompanyTwo";
import CompanyThree from "../pages/CompanyThree";
import CompanyFour from "../pages/CompanyFour";
import CompanyFive from "../pages/CompanyFive";
import CompanySix from "../pages/CompanySix";
import Newcomnay from '../pages/Newcomnay'
import Data from '../pages/Data'



const Layout = () => {
  return (

    <div>

      <Carousel />
      <CompanyOne />
      <CompanyThree />
      <CompanyFour />
      {/* <CompanySix /> */}
      <Data />
      <Owner />
      <Banner />
      <br />
      {/* <Founders /> */}
      <Videos />
      <Maps />
      <Footer />

    </div>

  )
}

export default Layout





 


